<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@core/utils/validations/validations';
import axios from '@/libs/axios';
import ModalReprovacao from '@/views/app/operacoes/pic/painel/ModalReprovacao.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import PicItem from './listPicitem/Index.vue';

export default {
  components: {
    ModalReprovacao,
    BModal,
    PicItem,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        tipopicid: '',
        tipopicdescricao: '',
        tipopicinformavalorbrutoliquido: '',
        tipopictipocontrole: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      dataFromApiTipoPicId: null,
      dataFromApiTipoPedidoId: null,
      optionsEstabelecimento: [],
      dataFromApiCondicaoPagamento: [],
      dataFromApiCanalVenda: [],
      dataFromApiCliente: [],
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === this.idModal) {
        this.onModalShow();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::show');
  },
  methods: {
    onModalShow() {
      this.fetchDataFromTipoPic();
      this.fetchDataFromEstabelecimento();
      this.fetchDataFromTipoPedido();
      this.fetchDataFromCanalVenda();
      this.fetchDataFromCondicaoPagamento();
      this.fetchDataFromCliente();
    },
    async validateForm() {
      this.$emit('ok', this.dataForm);
      this.$bvModal.hide(this.idModal);
    },
    async fecharModal() {
      this.$bvModal.hide(this.idModal);
    },
    async aprovarPic() {
      console.log('Aprovado');
      this.dataForm.picsituacao = 'Aprovada';
      const dataAprovacao = new Date();

      // Formata a data no padrão "dia mês ano"
      const dia = dataAprovacao.getDate().toString().padStart(2, '0');
      const mes = (dataAprovacao.getMonth() + 1).toString().padStart(2, '0'); // Os meses são base 0, então adicionamos 1
      const ano = dataAprovacao.getFullYear().toString();

      const dataFormatada = `${dia}/${mes}/${ano}`;
      console.log(dataFormatada);
      // Define a data de aprovação formatada no objeto dataForm
      this.dataForm.picdataaprovacao = dataFormatada;
      console.log('this.dataForm', this.dataForm);
      try {
        await axios.put(`/pic/${this.dataForm.picid}`, this.dataForm);
        await axios.post(`/pic-item/updateSituacao/${this.dataForm.picid}`, 'Aprovado');
        this.$bvModal.hide(this.idModal);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Pic aprovada com sucesso',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    toUpperCase() {
      this.dataForm.tipopicid = this.dataForm.tipopicid.toUpperCase();
    },
    async atualizarPIC() {
      console.log('this.dataForm', this.dataForm);
      try {
        const response = await axios.put(`/pic/${this.dataForm.picid}`, this.dataForm);
        this.$bvModal.hide(this.idModal);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Pic reprovada com sucesso',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromTipoPic() {
      try {
        const response = await axios.get('/tipo-pic');
        this.dataFromApiTipoPicId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromTipoPedido() {
      try {
        const response = await axios.get('/tipo-pedido');
        this.dataFromApiTipoPedidoId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromCanalVenda() {
      try {
        const response = await axios.get('/canal-venda');
        this.dataFromApiCanalVenda = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromCliente() {
      try {
        const response = await axios.get('/cliente/');
        this.dataFromApiCliente = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromCondicaoPagamento() {
      try {
        const response = await axios.get('/condicao-pagamento');
        this.dataFromApiCondicaoPagamento = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromEstabelecimento() {
      try {
        const response = await axios.get('/estabelecimento');
        this.optionsEstabelecimento = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
  },
};
</script>

<template>
  <b-modal no-close-on-backdrop no-close-on-esc size="xl" :id="idModal" :title="titleModal"
    :ok-disabled="dataForm.isDefault || dataForm.tipopicdescricao === ''" :ok-title="labelBtnOk" ok-variant="success"
    cancel-variant="danger" body-bg-variant="light" cancel-title="Reprovar" @close="$emit('cancel')">
    <template #modal-footer>
      <b-row>
        <b-col cols="4">
          <b-button variant="primary" @click="fecharModal">Fechar</b-button>
        </b-col>
        <b-col cols="4" v-if="dataForm.picsituacao != 'Reprovada' && dataForm.picsituacao != 'Aprovada'">
          <b-button variant="danger" v-b-modal.modal-reprovacao>Reprovar</b-button>
        </b-col>
        <b-col cols="4">
          <b-button variant="success" @click="aprovarPic"
            v-if="dataForm.picsituacao != 'Aprovada' && dataForm.picsituacao != 'Reprovada'">Aprovar</b-button>
        </b-col>
      </b-row>
    </template>
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Descrição" label-for="picdescricao">
              <validation-provider #default="{ errors }" name="Descrição" rules="required">
                <b-form-input v-model="dataForm.picdescricao" id="picdescricao" :state="errors.length > 0 ? false : null"
                  placeholder="Digite a descrição" disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Tipo Pic" label-for="tipopicid">
              <validation-provider #default="{ errors }" name="Descrição" rules="required">
                <b-form-input v-model="dataForm.DadosTipopic.tipopicdescricao" id="tipopicid"
                  :state="errors.length > 0 ? false : null" placeholder="Digite o código" disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Data Faturamento" label-for="picdatafaturamento">
              <validation-provider #default="{ errors }" name="picdatafaturamento" rules="required">
                <b-form-input v-model="dataForm.picdatafaturamento" id="picdatafaturamento"
                  :state="errors.length > 0 ? false : null" type="date" disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Validade Inicio" label-for="piciniciovalidade">
              <validation-provider #default="{ errors }" name="piciniciovalidade" rules="required">
                <b-form-input v-model="dataForm.piciniciovalidade" id="piciniciovalidade"
                  :state="errors.length > 0 ? false : null" type="date" disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Validade Termino" label-for="picterminovalidade">
              <validation-provider #default="{ errors }" name="picterminovalidade" rules="required">
                <b-form-input v-model="dataForm.picterminovalidade" id="picterminovalidade"
                  :state="errors.length > 0 ? false : null" type="date" disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Hora: " label-for="picterminovalidadehora">
              <validation-provider #default="{ errors }" name="picterminovalidadehora" rules="required">
                <b-form-input v-model="dataForm.picterminovalidadehora" id="picterminovalidadehora"
                  :state="errors.length > 0 ? false : null" type="time" disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Estabelecimento" label-for="estabelecimentoid">
              <validation-provider #default="{ errors }" name="estabelecimentoid" rules="required">
                <b-form-select v-model="dataForm.estabelecimentoid" id="estabelecimentoid"
                  :state="errors.length > 0 ? false : null" text-field="estabelecimentorazaosocial"
                  value-field="estabelecimentoid" :options="optionsEstabelecimento" disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1" v-if="dataForm.clienteid">
            <b-form-group label="Codigo Cliente" label-for="clienteid">
              <validation-provider #default="{ errors }" name="clienteid" rules="required">
                <b-form-input v-model="dataForm.clienteid" id="clienteid" :state="errors.length > 0 ? false : null"
                  disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1" v-if="dataForm.tipopicid !== 'PR'">
            <b-form-group label="Tipo Pedido" label-for="tipopedidoid">
              <validation-provider #default="{ errors }" name="tipopedidoid" rules="required">
                <b-form-select v-model="dataForm.tipopedidoid" id="tipopedidoid"
                  :state="errors.length > 0 ? false : null" text-field="tipopedidodescricao" value-field="tipopedidoid"
                  :options="dataFromApiTipoPedidoId" disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="4" class="mb-1">
            <b-form-group label="Tipo Frete" label-for="pictipofrete">
              <validation-provider #default="{ errors }" name="pictipofrete" rules="required">
                <b-form-input v-model="dataForm.pictipofrete" id="pictipofrete"
                  :state="errors.length > 0 ? false : null" disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Condicao Pagamento" label-for="condicaopagamentoid">
              <validation-provider #default="{ errors }" name="condicaopagamentoid" rules="required">
                <b-form-select v-model="dataForm.condicaopagamentoid" id="picaprovacao"
                  :state="errors.length > 0 ? false : null" text-field="condicaopagamentodescricao"
                  value-field="condicaopagamentoid" :options="dataFromApiCondicaoPagamento" disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" class="mb-1">
            <b-form-group label="Observação" label-for="picobservacaoaprovador">
              <validation-provider #default="{ errors }" name="picobservacaoaprovador" rules="required">
                <b-form-textarea v-model="dataForm.picobservacaoaprovador" id="picobservacaoaprovador"
                  :state="errors.length > 0 ? false : null" placeholder="Sem observação" disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

        </b-row>
      </b-form>
    </validation-observer>
    <div class="mt-2">
      <h3>Pic Item</h3>

      <PicItem :picidbusca="dataForm.picid" :tabprecoid="dataForm.DadosTipopic.tabprecoid" />
      <ModalReprovacao titleModal="Reprovar Pic" :labelBtnOk="'Enviar'" idModal="modal-reprovacao" v-model="dataForm"
        @salvar="atualizarPIC($event)" />

    </div>

  </b-modal>
</template>
